import { z } from "zod/v3";

import { itemSchema } from "~/lib/validators/items";

// TypeScript types for item form data - simplified schema for form UI
export const itemFormSchema = itemSchema
  .omit({
    modifierGroups: true,
    useCategoryModifiers: true,
    devicesIds: true,
  })
  .extend({
    price: z.string().min(1, "Price is required"),
    categories: z
      .array(z.string().cuid2())
      .min(1, "Choose at least one menu category"),
  });

export type ItemFormData = z.infer<typeof itemFormSchema>;

export type ModalTypes = "newItem" | "duplicate" | "existingItem";
